import request from '@/router/axios';

let baseUrl = ""

/**
 * 获取角色
 * @param {*} data
 * @returns
 */
/*export function getRoles(data) {
  return request(`${baseUrl}/jsondata/roles.json`, { params: data })
}*/
export function getRoles(data) {
  return request({
    url:`${baseUrl}/workflow/roles`,
    method:"post",
    data: data
  })
}
/**
 * 获取部门
 * @param {*} data
 * @returns
 */
/*export function getDepartments(data) {
  return request(`${baseUrl}/jsondata/departments.json`, { params: data })
}*/
export function getDepartments(data) {
  return request({
    url:`${baseUrl}/workflow/departments`,
    method:"post",
    data: data
  })
}
/**
 * 获取职员
 * @param {*} data
 * @returns
 */
/*export function getEmployees(data) {
  return request(`${baseUrl}/jsondata/employees.json`, { params: data })
}*/
export function getEmployees(data) {
  return request({
    url:`${baseUrl}/workflow/employees`,
    method:"post",
    data: data
  })
}
/**
 * 获取条件字段
 * @param {*} data
 * @returns
 */
export function getConditions(data) {
  return request(`${baseUrl}/jsondata/conditions.json`, { params: data })
}

/**
 * 获取审批数据
 * @param {*} data
 * @returns
 */
/*export function getWorkFlowData(data) {
  return request(`${baseUrl}/jsondata/data.json`, { params: data })
}*/
export function getWorkFlowData(data) {
  return request({
    url:`${baseUrl}/workflow/data`,
    method:"post",
    data: data
  })
}
/**
 * 设置审批数据
 * @param {*} data
 * @returns
 */
export function setWorkFlowData(data) {
  return request({
    url:`${baseUrl}/workflow/save`,
    method:"post",
    data: data
  })
}
